import { Button, Result } from "antd";
import React from "react";
import { Link } from "react-router-dom";
import styles from "./Notfound.module.css";
const Notfound = () => (
  <div className={styles.Notfound}>
    <Result
      status="404"
      title="404"
      subTitle="صفحه مورد نظر پیدا نشد."
      extra={
        <Link to="/">
          <Button type="primary">بازگشت به خانه</Button>
        </Link>
      }
    />
  </div>
);

export default Notfound;
